<template>
  <div>
    <reseller-header
      :reseller="reseller"
      :faqs="faqs"
    ></reseller-header>
    <div>
      <!-- <slot></slot> -->
      <router-view></router-view>
    </div>
    <reseller-footer
      :reseller="reseller"
      :termsAndConditions="termsAndConditions"
      :privacyPolicies="privacyPolicies"
    >
    </reseller-footer>
  </div>
</template>

<script>
import Repository from "@/api/repositories";

const ResellersApi = Repository.get("resellers");
const TermsAndConditionsApi = Repository.get("termsAndConditions");
const PrivacyPoliciesApi = Repository.get("privacyPolicies");
const FaqsApi = Repository.get("medgateAppFaqs");


export default {
  components: {
    ResellerHeader: () => import('@/components/reseller/Header.vue'),
    ResellerFooter: () => import('@/components/reseller/Footer.vue'),
  },
  data: () => ({
    resellerId: null,
    reseller: {},
    termsAndConditions: [],
    privacyPolicies: [],
    faqs: []
  }),
  watch: {
    resellerId: {
      handler: function(value) {
        if (value) {
          this.getTermsAndConditions();
          this.getPrivacyPolicies();
          this.getFaqs();
        }
      },
      immediate: true
    }
  },
  async mounted() {
    await this.getReseller();
  },
  methods: {
    async getReseller() {
      let slug = this.$route.params.slug;

      await ResellersApi
        .getDetailsViaSlug(slug)
        .then(response => {
          let {
            data: {
              data : item
            }
          } = response;

          console.log({ item });

          this.resellerId = item.id;
          this.reseller = item;
        })
        .catch(error => {
          console.log({ error });
        })
    },
    async getTermsAndConditions() {
      let params = {
        reseller_id: this.resellerId,
        order_by: "ASC"
      }

      await TermsAndConditionsApi
        .resellerGet({ params })
        .then(response => {
          let {
            data: {
              data : items
            }
          } = response;

          this.termsAndConditions = items.map(item => {
            return item.description;
          });
        })
        .catch(error => {
          console.log({ error });
        })
    },
    async getPrivacyPolicies() {
      let params = {
        reseller_id: this.resellerId,
        order_by: "ASC"
      }

      await PrivacyPoliciesApi
        .resellerGet({ params })
        .then(response => {
          let {
            data: {
              data : items
            }
          } = response;

          this.privacyPolicies = items.map(item => {
            return {
              title: item.title,
              content: item.description
            };
          });
        })
        .catch(error => {
          console.log({ error });
        })
    },
    async getFaqs() {
      let params = {
        reseller_id: this.resellerId,
        order_by: "ASC"
      }

      await FaqsApi
        .resellerGet({ params })
        .then(response => {
          console.log({ response });
          let {
            data: {
              data : items
            }
          } = response;

          console.log({ items })

          this.faqs = items.map(item => {
            return {
              question: item.question,
              answer: item.answer
            };
          });
        })
        .catch(error => {
          console.log({ error });
        })
    }
  }
}
</script>